import './ModalTicket.css'
import { Icon } from '@iconify/react';
import React, { useEffect, useState, useCallback } from "react";
import { deserializeFields, serializeFields, getActiveFields, popupInfo, popupError } from '../api/zendesk'
import { vtexProperties } from '../contants';
import Logo from '../assets/logovtex.png'
import Loading from '../components/Loading'

export default function ModalTicket() {
    const [fields, setFields] = useState([])
    const [zendeskFields, setZendeskFields] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [vtexZendeskMap, setVtexZendeskMap] = useState(vtexProperties)

    const filterFields = useCallback(async () => {

        const map = await deserializeFields()

        const savedFieldIds = Object.values(map).filter(s => s !== "" && s !== null)
        setVtexZendeskMap({ ...vtexProperties, ...map })

        const fields = await getActiveFields()
        setFields(fields)

        setZendeskFields(fields.filter(field => savedFieldIds.includes(field.id)))
        setLoaded(true)
    }, [setFields, setVtexZendeskMap, setZendeskFields, setLoaded])

    function sendField(fieldname, id) {
        const hasField = fields.find((f) => f.title === fieldname)
        if (hasField)
            setZendeskFields(s => [...s, { title: fieldname, id }])
    }

    const removeFields = (id) => {
        setZendeskFields(fields => fields.filter(field => field.id !== id))

        setVtexZendeskMap(state => {
            let newState = { ...state }
            for (const key of Object.keys(vtexZendeskMap)) {
                if (vtexZendeskMap[key] === id) {
                    delete newState[key]
                }
            }
            for (const [vtexKey, fieldId] of Object.entries(vtexZendeskMap)) {
                if (fieldId === id) {
                    delete newState[vtexKey]
                }
            }
            return newState
        })
    }

    function selectVtexFields(vtexField, ticketFieldId) {
        if (vtexField === '-') {
            // Nesse caso o usuario deselecionou (selecionou o -) o campo vtex do id zendesk
            setVtexZendeskMap(state => {
                const key = Object.entries(state).find((list) => parseInt(list[1]) === ticketFieldId)[0]
                return { ...state, [key]: "" }
            })
        } else {
            setVtexZendeskMap(state => {
                return { ...state, [vtexField]: ticketFieldId }
            })
        }
    }

    function search() {
        return fields
            .filter(f => !zendeskFields.map(f => f.id).includes(f.id))
            .filter(field => field.title.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase().trim()))
    }

    function isSelected(zendeskFieldId) {
        const item = Object.entries(vtexZendeskMap).find((list) => parseInt(list[1]) === zendeskFieldId)
        if (item) {
            return item[0]
        }
        return ""
    }

    function getUnlinkedKeys(fieldId) {
        // Retorna todas as chaves Vtex que não estão sendo usadas e a chave usada pelo campo de ticket atual (fieldId)
        // isso é feito para que o usuario não adicione acidentalmente a mesma chave vtex em dois campos de ticket
        const getKeysFromEntry = ([key, _]) => key
        const keys = Object.entries(vtexZendeskMap).filter(([_, value]) => value === 0).map(getKeysFromEntry)
        const [key] = Object.entries(vtexZendeskMap).filter(([_, value]) => value === parseInt(fieldId, 10)).map(getKeysFromEntry)
        return [...keys, key]
    }

    useEffect(() => { filterFields() }, [filterFields])

    if (!loaded) {
        return<div className="container-loading">
            <Loading />
        </div>
    }

    return (

        <div className="container-modal">
            <div className="header-modal">
                <img src={Logo} alt="Logo vtex" />
            </div>
            <div className='fields'>
                <h1>Vincular Campos</h1>
                <div className='header-fields'>
                    <h1>Campo Zendesk</h1>
                    <h1>Campo Vtex</h1>
                </div>
                <div className='container-fields'>

                    <div className='conteudo-fields'>
                        {zendeskFields.map(field => (
                            <div className='fields-modal' key={field.id}>
                                <button onClick={() => removeFields(field.id)}>
                                    <p>{field.title}</p>
                                    <Icon icon="bx:trash" />
                                </button>
                                <select
                                    defaultValue={isSelected(field.id)}
                                    onChange={(e) => selectVtexFields(e.target.value, field.id)}>
                                    <option>-</option>
                                    {/* NOTE: não alterar a key pois getUnlinkedKeys 
                                                renderiza as options a partir dela (ignorar o warning) */}
                                    {getUnlinkedKeys(field.id).map(item =>
                                        <option key={item}>{item}</option>
                                    )}
                                </select>
                            </div>
                        ))}
                    </div>
                    <div className='search-modal'>
                        <input onChange={(e) => setSearchInput(e.target.value.trim())}
                            maxLength={64} placeholder="Pesquisar"
                        />
                        <div className='button-search'>

                            <div>
                                {search().map(ticket_fields =>
                                    <div key={ticket_fields.id}>
                                        <button onClick={() => sendField(ticket_fields.title, ticket_fields.id)}> + {ticket_fields.title} </button>
                                    </div>)}
                            </div>
                        </div>

                    </div>
                </div>
                <div className='footer-modal'>
                    <small>Relacione quais campos devem ser preenchidos na Zendesk com o conteúdo
                        que está no VTEX (essa informação só é preenchida no campo com o
                        botão “Salvar” dentro do app)
                    </small>
                    <button onClick={() => {
                    serializeFields(vtexZendeskMap).then(_ => {
                        popupInfo('Dados salvos com sucesso!')
                    }).catch(e => {
                        console.log('vtex zendesk(error)', e)
                        popupError('Ocorreram erros ao salvar suas alterações. ' +
                            'Contate o suporte caso o problema persista.', true)
                    })
                }
                }> Salvar</button>
                </div>
            </div>

        </div>

    )

}
